export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.02344 21.5C3.39369 21.4999 2.88394 20.9886 2.88379 20.3574L2.88477 10.9092C2.88494 10.278 3.39464 9.76666 4.02441 9.7666H6.51074V7.27637C6.51087 6.64514 7.02053 6.13379 7.65039 6.13379H10.1348V3.64258C10.1349 3.01138 10.6455 2.5 11.2754 2.5H19.9766C20.6063 2.50016 21.117 3.01148 21.1172 3.64258V20.3574C21.117 20.9885 20.6063 21.4998 19.9766 21.5H4.02344ZM18.8359 4.78613H12.4141L12.415 11.2207H18.8359V4.78613ZM18.8359 13.5059H11.2744C10.6445 13.5058 10.1338 12.9946 10.1338 12.3633L10.1348 8.41992H8.79004V15.5801H18.8359V13.5059ZM18.8359 17.8662H7.64941C7.01956 17.8662 6.50989 17.3549 6.50977 16.7236V12.0527H5.16406L5.16504 19.2139H18.8359V17.8662Z"
      fill="currentColor"
    />
  </svg>
);
